import script from "./DiscountCodeInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiscountCodeInput.vue?vue&type=script&setup=true&lang=ts"

import "./DiscountCodeInput.vue?vue&type=style&index=0&id=9af12280&scoped=true&lang=css"

import exportComponent from "../../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9af12280"]])

export default __exports__